// extracted by mini-css-extract-plugin
export default {"container":"index-module__q8ajl","descriptionContainer":"index-module__VFezl"};